export default __webpack_public_path__ + "static/media/stop.73b7c7b4.svg";